import { useInfiniteQuery } from '@tanstack/react-query';
import { compact, reduce } from 'lodash';
import { useMemo } from 'react';
export const useSliderItems = ({ fetchItems, queryId, topicId, }) => {
    var _a, _b, _c;
    const { data, fetchNextPage, hasNextPage, isError, isFetchingNextPage, isLoading, } = useInfiniteQuery({
        queryKey: [queryId, topicId],
        queryFn: ({ pageParam: page, signal }) => fetchItems({
            page,
            signal,
        }),
        initialPageParam: 1,
        getNextPageParam: (lastPage, pages) => {
            if (!lastPage || lastPage.totalItems === 0) {
                return null;
            }
            const itemsLength = pages.reduce((acc, { items: reduceItems }) => acc + reduceItems.length, 0);
            return itemsLength < lastPage.totalItems ? pages.length + 1 : null;
        },
        staleTime: 5 * 60 * 1000,
        retry: false,
    });
    const items = useMemo(() => reduce(compact(data === null || data === void 0 ? void 0 : data.pages), (acc, { items: compactItems }) => acc.concat(compactItems), []), [data === null || data === void 0 ? void 0 : data.pages]);
    return {
        fetchNextPage: hasNextPage ? fetchNextPage : null,
        isError,
        isLoading: isLoading || isFetchingNextPage,
        items,
        total: (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.pages) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.totalItems) !== null && _c !== void 0 ? _c : 0,
    };
};
//# sourceMappingURL=useSliderItems.js.map